import type {Dayjs} from 'dayjs'
import type {UserSettings} from '@package/shared'

export const formatTime = (date: Dayjs, userSettings: UserSettings) => {
  return date.toDate().toLocaleTimeString(undefined, {
    timeZone: userSettings.timezone,
    hour: '2-digit',
    minute: '2-digit',
    hour12: userSettings.timeFormat === '12h',
  })
}
